/**
 * One frame of analysed audio. All scalar values are normalised to [0, 1].
 * This is the single contract between the audio side and the visual side:
 * everything the renderer reacts to comes through this object.
 */
export interface AudioFrame {
  /** Overall loudness across the full spectrum. */
  readonly level: number;
  /** Energy in the bass band (~20–160 Hz): kicks, sub bass. */
  readonly bass: number;
  /** Energy in the mid band (~160–2000 Hz): vocals, synths. */
  readonly mid: number;
  /** Energy in the treble band (~2–8 kHz): hats, sparkle. */
  readonly treble: number;
  /** True on the exact frame a beat onset was detected. */
  readonly beat: boolean;
  /** Strength of the detected beat, 0 when `beat` is false. */
  readonly beatIntensity: number;
}

export const SILENT_FRAME: AudioFrame = {
  level: 0,
  bass: 0,
  mid: 0,
  treble: 0,
  beat: false,
  beatIntensity: 0,
};
